var render, staticRenderFns
import script from "./UiTextButton.vue?vue&type=script&lang=js"
export * from "./UiTextButton.vue?vue&type=script&lang=js"
import style0 from "./UiTextButton.vue?vue&type=style&index=0&id=06cea088&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports